import { FORM_BUILDER_FIELD_TYPE } from "@loanbossinc/component-library";

export const rows = {
  title: {
    isTitle: true,
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.TEXT,
        value: "Guaranty",
        style: {
          marginLeft: "0",
          fontFamily: "Work Sans",
          fontStyle: "normal",
          fontWeight: "500",
          fontSize: "16px",
          lineHeight: "14px",
          textTransform: "uppercase",
          color: "#000000",
          marginBottom: "10px"
        }
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.REFERENCE,
        referencedFieldPath: "loans.guaranty.header"
      }
    ]
  },
  guarantyType: {
    label: "Recourse Type",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.TYPEAHEAD,
        key: "recourseTypeId",
        name: "recourse.recourseTypeId",
        variant: "filled",
        parentId: "recourseTypes",
        displayWith: option => option.name,
        setValueWith: option => option.id,
        onChange: value => {
          console.log("onChange", { value });
        }
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.REFERENCE,
        referencedFieldPath: "loans.recourse.recourseTypeId"
      }
    ]
  },
  carveouts: {
    label: "Carveouts",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.STRING,
        name: "recourse.carveouts",
        variant: "filled",
        multiline: true
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.REFERENCE,
        referencedFieldPath: "loans.recourse.carveouts"
      }
    ]
  },
  guarantorCalculation: {
    label: "Guarantor Calculation",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.INPUTRADIO,
        handleRadioButtonChange: (formik, items, value) => {
          formik.setFieldValue("recourse.recourseCalculationMethod", value);
        },
        value: "recourse.recourseCalculationMethod",
        options: ["Cumulative", "Shared"]
      }
    ]
  },
  misc: {
    label: "Misc",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.STRING,
        name: "recourse.misc",
        variant: "filled",
        multiline: true
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.REFERENCE,
        referencedFieldPath: "loans.recourse.misc"
      }
    ]
  }
};
